import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

export default function sentryConfig() {
  if (
    process.env.NODE_ENV === 'production' &&
    process.env.REACT_APP_SENTRY_RELEASE
  ) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [new Integrations.BrowserTracing()],
      environment: process.env.CI_ENVIRONMENT_NAME,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      release: process.env.REACT_APP_SENTRY_RELEASE,
    });
  }
}
